import React, { useState } from "react";
import { Footer } from "./components/Footer";
import { Header } from "./components/Header";
import MarcasProvider from "./context/MarcasContext";
import Modal from "react-bootstrap/Modal";

import portadaPosventa from "./assets/images/posventa/portadaPosventa.png";

import titulo1 from "./assets/images/posventa/titulo1.png";
import titulo2 from "./assets/images/posventa/titulo2.png";
import titulo3 from "./assets/images/posventa/titulo3.png";

import iconoEstrella from "./assets/images/posventa/estrella.png";
import badgeGratis from "./assets/images/posventa/badgeGratis.png";

import IconClose from "./assets/images/posventa/IconClose.png";
import FormularioEstructura from "./components/Formulario/FormularioEstructura";

import logoMarcasMobile from "./assets/images/posventa/logoMarcasMobile.png";

function App() {
  // Mas info
  const [showInfo, setShowInfo] = useState({
    modalBasic: false,
    modalPremiun: false,
    modalCheckpoints: false,
  });

  const handleCloseInfo = () => {
    setShowInfo({
      modalBasic: false,
      modalPremiun: false,
      modalCheckpoints: false,
    });
  };
  const handleShowInfo = (modal) => {
    setShowInfo({ [modal]: true });
  };

  // Reservar turno
  const [showTurno, setShowTurno] = useState({
    mostrarModal: false,
    categoriaSeleccionada: "",
  });

  const handleCloseTurno = () => {
    setShowTurno({
      mostrarModal: false,
      categoriaSeleccionada: "",
    });
  };
  const handleShowTurno = (categoria) => {
    setShowTurno({
      mostrarModal: true,
      categoriaSeleccionada: categoria,
    });
  };

  return (
    <MarcasProvider>
      <Header />
      <section className="contenedorCentral">
        <div>
          <h1 className="tituloPrincipal">cuidamos tu okm</h1>
          <h2 className="SubtituloPrincipal"> ¿Qué tipo de servicio necesitás?</h2>
        </div>
        <div>
          <img src={portadaPosventa} alt="Foto Portada" className="portadaMobileMargen" />
          <img src={logoMarcasMobile} alt="Logo Marcas Montironi" className="MostrarCelular logoMarcasMobile" />
        </div>
      </section>
      <section className="contenedorCards">
        <div className="cards">
          <h3>
            <img src={titulo1} alt="Title" />
          </h3>
          <p>¿Qué incluye este servicio?</p>
          <button className="btnVerDetalle" onClick={() => handleShowInfo("modalBasic")}>
            Ver detalle
          </button>
          <button className="btnAgendarTurno" onClick={() => handleShowTurno("Service Basico")}>
            Agendar turno
          </button>
        </div>
        <div className="cards">
          <h3>
            <img src={titulo2} alt="Title" />
          </h3>
          <p>¿Qué incluye este servicio?</p>
          <button className="btnVerDetalle" onClick={() => handleShowInfo("modalPremiun")}>
            Ver detalle
          </button>
          <button className="btnAgendarTurno" onClick={() => handleShowTurno("Service Premium")}>
            Agendar turno
          </button>
          <img src={iconoEstrella} alt="Icono estrella" className="iconoEstrellaFlotante" />
        </div>
        <div className="cards">
          <h3>
            <img src={titulo3} alt="Title" />
          </h3>
          <p>¿Qué incluye este servicio?</p>
          <button className="btnVerDetalle" onClick={() => handleShowInfo("modalCheckpoints")}>
            Ver detalle
          </button>
          <button className="btnAgendarTurno" onClick={() => handleShowTurno("Checkpoint")}>
            Agendar turno
          </button>
          <img src={badgeGratis} alt="Badge Gratis" className="badgeFlotante" />
        </div>
      </section>
      <Footer />

      {/* Service basico*/}
      <Modal show={showInfo.modalBasic} onHide={handleCloseInfo}>
        <div className="contenedorMasInformacionModal">
          <div className="contenedoTitleModal">
            <img src={titulo1} className="imagenPrincipalTitle" alt="Title" />
            <img src={IconClose} onClick={handleCloseInfo} className="iconCloseModal" alt="Close" />
          </div>
          <p>¿Qué incluye éste servicio?</p>
          <ul>
            <li>Diagnóstico computarizado con herramientas oficiales.</li>
            <li>Lubricación de cerraduras.</li>
            <li>Control de chasis, tren delantero, tren traseros y frenos.</li>
            <li>Control de conductos bajo chasis (de escape y combustible).</li>
            <li>Control y complemento de fluidos (líquido refrigerante, freno, limpiaparabrisas).</li>
            <li>Control de luces y pack eléctrico.</li>
            <li>Control de actualizaciones técnicas.</li>
            <li>Lavado de unidad.</li>
          </ul>
          <h6>Cambio de: </h6>
          <ul>
            <li>Filtro de aceite.</li>
            <li>Filtro de combustible.</li>
            <li>Filtro de aire.</li>
            <li>Filtro de Habitáculo (A/C).</li>
            <li>Aceite correspondiente (litros).</li>
          </ul>
          <button className="btnAgendarTurno" onClick={handleShowTurno}>
            Agendar turno
          </button>
        </div>
      </Modal>

      {/* Service premiun*/}
      <Modal show={showInfo.modalPremiun} onHide={handleCloseInfo}>
        <div className="contenedorMasInformacionModal">
          <div className="contenedoTitleModal">
            <img src={titulo2} className="imagenPrincipalTitle" alt="Title" />
            <img src={IconClose} onClick={handleCloseInfo} className="iconCloseModal" alt="Close" />
          </div>
          <p>¿Qué incluye éste servicio?</p>
          <ul>
            <li>Control y complemento de fluidos (líquido refrigerante, freno, limpiaparabrisas)</li>
            <li>Control de luces y pack eléctrico.</li>
            <li>Control de actualizaciones técnicas.</li>
            <li>Lavado de unidad.</li>
            <li>Diagnóstico computarizado con herramientas oficiales.</li>
            <li>Lubricación de cerraduras.</li>
            <li>Control de chasis, tren delantero, tren traseros y frenos.</li>
            <li>Control de conductos bajo chasis (de escape y combustible).</li>
          </ul>
          <h6>Cambio de: </h6>
          <ul>
            <li>Filtro de aceite.</li>
            <li>Filtro de combustible.</li>
            <li>Filtro de aire.</li>
            <li>Filtro de Habitáculo (A/C).</li>
            <li>Aceite correspondiente (litros).</li>
          </ul>
          <h6>ADEMÁS: </h6>
          <ul>
            <li>Alineado, balanceado y rotación de neumáticos.</li>
            <li>
              Servicio de movilidad (te brindamos un auto gratis para poder transladarte durante lo que dure tu service)
            </li>
            <li>Filtro de habitáculo si corresponde.</li>
          </ul>
          <button className="btnAgendarTurno" onClick={handleShowTurno}>
            Agendar turno
          </button>
        </div>
      </Modal>

      {/* Service checkpoint*/}
      <Modal show={showInfo.modalCheckpoints} onHide={handleCloseInfo}>
        <div className="contenedorMasInformacionModal">
          <div className="contenedoTitleModal">
            <img src={titulo3} className="imagenPrincipalTitle" alt="Title" />
            <img src={IconClose} onClick={handleCloseInfo} className="iconCloseModal" alt="Close" />
          </div>
          <p>¿Qué incluye éste servicio?</p>
          <ul>
            <li>Calibración de neumáticos</li>
            <li>Nivelación de fluídos</li>
            <li>Escaner de fallas</li>
            <li>Control de funcionalidades. </li>
            <li>Control de luces. </li>
            <li>Lubricación de cerraduras.</li>
          </ul>
          <button className="btnAgendarTurno" onClick={handleShowTurno}>
            Agendar turno
          </button>
        </div>
      </Modal>

      <Modal show={showTurno.mostrarModal} onHide={handleCloseTurno}>
        <div className="contenedoTitleModalTurno">
          <h5>Rellena los campos</h5>
          <img src={IconClose} onClick={handleCloseTurno} className="iconCloseModal" alt="Close" />
        </div>
        <div className="contenedoBodyModalTurno">
          <p>
            Completa un formulario y un asesor se <br />
            comunicara para coordinar el turno en <br />
            una de nuestras sucursales.
          </p>
        </div>
        <div className="contenedoBodyModalForm">
          <FormularioEstructura categoriaSeleccionada={showTurno.categoriaSeleccionada} />
        </div>
      </Modal>
    </MarcasProvider>
  );
}

export default App;
